import { render } from "./PlayButtonComponent.vue?vue&type=template&id=fc4f0ef0&scoped=true&ts=true"
import script from "./PlayButtonComponent.vue?vue&type=script&lang=ts"
export * from "./PlayButtonComponent.vue?vue&type=script&lang=ts"

import "./PlayButtonComponent.vue?vue&type=style&index=0&id=fc4f0ef0&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4f0ef0"]])

export default __exports__